<template>
    <div class="index-page">
        <PageTopBar></PageTopBar>
        <pageHeaderBar></pageHeaderBar>
        <SideBar></SideBar>
        <MenuBar></MenuBar>
        <div class="grey-body">
            <div class="list-bread">
                <a :href="webRoot">首页</a>
                <span>></span>
                <a>医生列表</a>
            </div>
            <div class="list-body doctor-list">
                <div class="search-area">
                    <ul>
                        <li class="more-list" id="doctor-area">
                            <span class="area-txt">区&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;域：</span>
                            <div class="search-list list limited dist">
                                <label :class="returnClassName(index, item.isSelected)" :data-index="index"
                                       :title="item.name"
                                       v-for="(item, index) in districtList"
                                       @click="getNewDist(index, item.areaId,item.isSelected)"><p>{{item.name}}</p>
                                </label>
                                <div class="de-more" v-if="districtList.length > 10" @click="areaMore">
                                    更多
                                    <div class="triangle triangle-down" id="area-triangle"></div>
                                </div>
                            </div>
                        </li>
                        <li class="more-list" id="doctor-depart">
                            <span class="area-txt">科&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;室：</span>
                            <div class="search-list list limited">
                                <label :class="returnClassName(index, item.isSelected)" :data-index="index"
                                       :title="item.departmentName"
                                       v-for="(item, index) in departmentsList"
                                       @click="getNewDep(index, item.isSelected)"><p>
                                    {{item.departmentName}}</p></label>
                                <div class="de-more" v-if="departmentsList.length > 10" @click="departMore">
                                    更多
                                    <div class="triangle triangle-down" id="depart-triangle"></div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <span class="area-txt">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</span>
                            <div class="search-list list limited">
                                <label :class="returnClassName(index, item.isSelected)" :data-index="index"
                                       :title="item.dictDescription"
                                       v-for="(item, index) in jobTitle"
                                       @click="getJobtit(index, item.isSelected)"><p>
                                    {{item.dictDescription}}</p></label>
                            </div>
                        </li>
                    </ul>
                </div>

                <LoadingBar height="120px" v-if="searchLoading"></LoadingBar>
                <div class="list-content clearfix" id="list-box" v-if="listShow">
                    <div class="list-left recommed-doctor">
                        <div class="doctor-list-item">
                            <template v-for="(item, index) in doctorListData" v-if="doctorListData.length>0">
                                <div class="clinic-groom clearfix">
                                    <a :href="appointmentImm(item.id)" class="doc-portrait">
                                        <img v-if="item.doctorPhoto" class="doc-img" :src="returnDoctorLog(item.doctorPhoto)"
                                             :onerror="defaultErrorImg" alt="">
                                        <img v-else="" class="doc-img" :src="defaultErrorImg"
                                             :onerror="defaultErrorImg" alt="">
                                    </a>
                                    <div class="doc-list">
                                        <ul>
                                            <li>
                                                <h1 class="doctor-name"><a
                                                        :href="appointmentImm(item.id)">{{item.doctorName}}</a></h1>
                                                <span v-if="item.medicineTitle && item.medicineTitle != '医师'"
                                                      style="position:relative;top:-3px;font-size: 12px;padding:0 3px;color: #259bef;border: 1px solid #259bef;margin:0 0 12px 8px;border-radius: 2px;">{{item.medicineTitle}}</span>
                                            </li>
                                            <li>
                                                <p>{{item.diagnosisType1}}</p>
                                            </li>
                                            <li>
                                                <p>从业经验：未录入</p>
                                                <p v-if="item.practiceBeginDate">
                                                    从业经验：<span>{{item.practiceBeginDate | workingTime}}年以上</span></p>
                                            </li>
                                            <li>
                                                <p style="overflow: hidden;white-space: nowrap;text-overflow:ellipsis;">
                                                    擅&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;长：{{item.goodArea}}</p>
                                            </li>
                                            <li>
                                                <a :href="returnClinicHref(item.clinicId)">
                                                    <p style="float: left;">诊&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;所：</p>
                                                    <p style="color:#259bef;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;">{{item.clinicName}}</p>
                                                </a>

                                            </li>
                                        </ul>
                                    </div>
                                    <div class="operating">
                                        <div class="btn-follow" @click="unfollowFun(item.id,index)"
                                             v-if="item.isConcern">
                                            <span class="follow"></span><em>已关注</em>
                                        </div>
                                        <div v-if="!item.isConcern" class="btn-follow"
                                             @click="followFun(item.id,index)">
                                            <span class="unfollow"></span><em>立即关注</em>
                                        </div>

                                        <p class="timeplan" v-if="item.clinic && item.linic.openingTime">
                                            {{item.workingTime}}</p>
                                        <p class="timeplan" v-else>周一至周日  上午8:00-下午10:00</p>
                                        <a class="btn-reserve" :href="appointmentImm(item.id)">立即预约</a>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="no-match" v-if="doctorListData.length==0">
                            <p><i></i>未搜索到符合条件的医生</p>
                        </div>
                        <Page :total="totalCount" :current="pageNo" :page-size="pageSize" class="list-page"
                              @on-change="changePage" v-if="totalCount"></Page>
                    </div>
                    <div class="list-right" v-if="recommendClinic.length > 0">
                        <h1>推荐诊所</h1>
                        <ul>
                            <li v-for="(item, index) in recommendClinic">
                                <a :href="returnClinicHref(item.clinicId)">
                                    <div class="pro-img">
                                        <img :src="nginxRoot + item.clinicFacadeName" :onerror="defaultClinicImg" alt="">
                                    </div>
                                    <div class="pro-name">{{item.clinicName}}</div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <FooterBar></FooterBar>
        <MsgDialog></MsgDialog>
        <LoginDialog @on-success="loginSuccessCallBack"></LoginDialog>
    </div>
</template>
<script>
    import PageTopBar from './../Common/pageTopBar';
    import pageHeaderBar from './../Common/pageHeaderBar';
    import SideBar from './../Common/sideBar';
    import FooterBar from './../Common/footerBar'
    import LoginDialog from './../Common/LoginDialog';
    import LoadingBar from './../Utils/loadingBar';
    import MenuBar from './../Common/menuBar';
    import '../../../static/js/utils/scrollLoading';
    import axios from 'axios';
    import MsgDialog from './../Common/msgDialog';
    import url from '../../../config/url';
    import common from '../../../static/js/common'
    import {mapMutations, mapGetters} from 'vuex'

    export default {
        components: {
            PageTopBar: PageTopBar,
            LoadingBar: LoadingBar,
            SideBar: SideBar,
            pageHeaderBar: pageHeaderBar,
            FooterBar: FooterBar,
            MenuBar: MenuBar,
            LoginDialog: LoginDialog,
            MsgDialog:MsgDialog
        },
        data() {
            return {
                defaultErrorImg: "this.src='https://www.pinganwj.com/resources/static/img/userlogo.png'",
                defaultClinicImg: 'this.src="https://image.pinganwj.com//web/default/clinic.jpg?resourceVersion=1510238521419"',
                webRoot: url.commonRoot,
                districtList: [],
                departmentsList: [],
                doctorListData: [],
                pageNo: parseInt(this.$route.query.pageNo) || 1,
                totalCount: 0,
                pageSize: 10,
                nginxRoot: window.nginxRoot + '/middle/',
                searchLoading: true,
                recommendClinic: [],  //推荐诊所信息
                listShow:false,
                jobTitle:[],
                areaShow:false,
                departShow:false
            }
        },
        filters: {
            workingTime(val) {
                if (val) {
                    return new Date().getFullYear() - parseInt(val) + 1;
                }
            }
        },
        methods: {
            ...mapMutations([
                'setKeyWord'
            ]),
            returnDoctorLog(logo){
                return logo.replace("http:", "");
            },
            returnClinicHref(clinicId){
                return window.commonRoot + "/clinic/detail/" + clinicId;
            },
            initData() {
                this.setKeyWord();
                this.getDistrictList();
                this.getDepartmentsList();
                this.getJobtitList();
                this.searchLoading = true;
                this.doctorList()
                this.getRecommendClinic();
            },
            changePage(pageIndex) {
                this.pageNo = pageIndex;
                this.doctorList();
                $('body,html').animate({
                    scrollTop: $('#list-box').offset().top - 10
                }, 0);
                return false;
            },
            judgeLogin() {
                var userInfo = this.$store.state.userInfo;
                if (userInfo != null && userInfo.userId > 0) {
                    return true;
                } else {
                    window.location.href = url.loginUrl;
                    return false;
                }
            },
            loginSuccessCallBack() {
                //登陆成功之后的操作
                this.$forceUpdate();
                this.doctorList();
            },
            //选中的样式
            returnClassName(index, isSelected) {
                if (index == 0) {
                    if (isSelected) {
                        return "first-label ivu-checkbox-wrapper  ivu-checkbox-wrapper-checked";
                    } else {
                        return "first-label ivu-checkbox-wrapper";
                    }
                } else {
                    if (isSelected) {
                        return "ivu-checkbox-wrapper  ivu-checkbox-wrapper-checked";
                    } else {
                        return "ivu-checkbox-wrapper";
                    }
                }
            },
            //区域选择
            getNewDist(index, areaId, isSelected) {
                if (isSelected == "undefined") {
                    isSelected = false;
                }
                //点击不限
                if (index == 0) {
                    if (isSelected) {
                        return
                    } else {
                        this.districtList.forEach((item, i) => {
                            if (i > 0) {
                                this.districtList[i]["isSelected"] = false;
                            }
                        });
                        this.districtList[0]["isSelected"] = true;
                    }
                } else {
                    if (isSelected) {
                        var len = 0;
                        this.districtList.forEach((item, i) => {
                            if (i > 0 && item.isSelected) {
                                len++;
                            }
                        });
                        if (len == 1) {
                            this.districtList[0]["isSelected"] = true;
                        }
                        this.districtList[index]["isSelected"] = false;

                    } else {
                        this.districtList[0]["isSelected"] = false;
                        this.districtList[index]["isSelected"] = true;
                    }
                }
                //初始化pageNo
                this.pageNo = 1;
                this.$forceUpdate();
                this.doctorList();

            },
            //科室选择
            getNewDep(index, isSelected) {
                if (isSelected == "undefined") {
                    isSelected = false;
                }
                //点击不限
                if (index == 0) {
                    if (isSelected) {
                        return
                    } else {
                        this.departmentsList.forEach((item, i) => {
                            if (i > 0) {
                                this.departmentsList[i]["isSelected"] = false;
                            }
                        });
                        this.departmentsList[0]["isSelected"] = true;
                    }
                } else {
                    if (isSelected) {
                        var len = 0;
                        this.departmentsList.forEach((item, i) => {
                            if (i > 0 && item.isSelected) {
                                len++;
                            }
                        });
                        if (len == 1) {
                            this.departmentsList[0]["isSelected"] = true;
                        }
                        this.departmentsList[index]["isSelected"] = false;

                    } else {
                        this.departmentsList[0]["isSelected"] = false;
                        this.departmentsList[index]["isSelected"] = true;
                    }
                }

                //初始化pageNo
                this.pageNo = 1;
                this.$forceUpdate();
                this.doctorList();
            },

            getJobtit(index, isSelected) {
                if (isSelected == "undefined") {
                    isSelected = false;
                }
                //点击不限
                if (index == 0) {
                    if (isSelected) {
                        return
                    } else {
                        this.jobTitle.forEach((item, i) => {
                            if (i > 0) {
                                this.jobTitle[i]["isSelected"] = false;
                            }
                        });
                        this.jobTitle[0]["isSelected"] = true;
                    }
                } else {
                    if (isSelected) {
                        var len = 0;
                        this.jobTitle.forEach((item, i) => {
                            if (i > 0 && item.isSelected) {
                                len++;
                            }
                        });
                        if (len == 1) {
                            this.jobTitle[0]["isSelected"] = true;
                        }
                        this.jobTitle[index]["isSelected"] = false;

                    } else {
                        this.jobTitle[0]["isSelected"] = false;
                        this.jobTitle[index]["isSelected"] = true;
                    }
                }

                //初始化pageNo
                this.pageNo = 1;
                this.$forceUpdate();
                this.doctorList();
            },

            //获取区域list
            getDistrictList() {
                let params = {
                    cityCode: window.areaId,
                };
                axios.get(url.districtList, {
                    params: params
                }).then((response) => {
                    let res = response.data;
                    if (res.status == "SUCCESS") {
                        this.districtList = [
                            {
                                name: "不限",
                                areaId: 0,
                                isSelected: true
                            }
                        ];
                        this.districtList = this.districtList.concat(res.result);
                    }
                }).catch(() => {
                    console.log('数据获取失败,请稍后再试!');
                });
            },
            //科室list
            getDepartmentsList() {
                axios.post(url.department).then(response => {
                    let res = response.data;
                    if (res.status == "SUCCESS") {
                        this.departmentsList = [
                            {
                                departmentName: "不限",
                                isSelected: true
                            }
                        ];
                        this.departmentsList = this.departmentsList.concat(res.result);
                    }
                }).catch(err => {
                    console.log('数据获取失败,请稍后再试!');
                })

            },
            //获取职称
            getJobtitList() {
                axios.get(url.getDoctorMedicineTitleList).then(response => {
                    let res = response.data;
                    if (res.status == "SUCCESS") {
                        this.jobTitle = [
                            {
                                dictDescription: "不限",
                                isSelected: true
                            }
                        ];
                        this.jobTitle = this.jobTitle.concat(res.result);
                    }
                }).catch(err => {
                    console.log('数据获取失败,请稍后再试!');
                })
            },

            //根据条件展示列表数据
            doctorList() {
                var dist = [];
                var departments = [];
                var medicineTitleNames = [];
                // 获取选中区域参数;
                this.districtList.forEach((item, index) => {
                    if (index > 0 && item.isSelected) {
                        dist.push(item.name);
                    }
                });

                this.departmentsList.forEach((item, index) => {
                    if (index > 0 && item.isSelected) {
                        departments.push(item.departmentId);
                    }
                });

                this.jobTitle.forEach((item, index) => {
                    if (index > 0 && item.isSelected) {
                        medicineTitleNames.push(item.dictDescription);
                    }
                });

                let params = {
                    cityCode: window.areaId,
                    pageSize: this.pageSize,
                    pageNo: this.pageNo,
                    districtNames: dist.join(','),
                    deptIds: departments.join(','),
                    keyWords: this.keyWord,
                    medicineTitleNames:medicineTitleNames.join(',')
                }


                axios({
                        url: url.doctorPage,
                        method: 'post',
                        data: params,
                        transformRequest: [function (data) {
                            let ret = [];
                            for (let it in data) {
                                ret.push(encodeURIComponent(it) + '=' + encodeURIComponent(data[it]))
                            }
                            return ret.join("&");
                        }],
                    }
                ).then((res) => {
                    if (res.data.status == "SUCCESS" && res.data.result != null && res.data.result.results != null) {
                        this.listShow = true;
                        this.searchLoading = false;
                        this.totalCount = res.data.result.totalCount;
                        this.doctorListData = res.data.result.results;
                    }
                }).catch(() => {
                    this.searchLoading = false;
                    console.log('数据获取失败,请稍后再试!');
                });



            },
            //点击关注按钮
            followFun(id, index) {
                var flag = this.judgeLogin();
                if (flag) {
                    var params = {
                        doctorId: id,
                    };
                    axios.get(url.insertDoctorConcern, {
                        params: params
                    }).then((response) => {
                        var res = response.data;
                        if (res.status == "SUCCESS") {
                            this.doctorListData[index].isConcern = '1';
                        }
                    }).catch((error) => {
                        this.$Message.error(error, '数据获取失败,请稍后再试!');
                    });
                }
                console.log(flag, '关注按钮点击操作')
            },
            //取消关注按钮
            unfollowFun(id, index) {
                var params = {
                    doctorId: id,
                };
                axios.get(url.deleteDoctorConcern, {
                    params: params
                }).then((response) => {
                    var res = response.data;
                    if (res.status == "SUCCESS") {
                        this.doctorListData[index].isConcern = false;
                    }
                }).catch((error) => {
                    this.$Message.error(error, '数据获取失败,请稍后再试!');
                });
            },
            appointmentImm(id) {
                return window.commonRoot + "/doctor/detail" + "/" + id;
            },
            getRecommendClinic() {
                var params = {
                    cityCode: window.areaId,
                };
                axios.get(url.getClinicInfo, {
                    params: params
                }).then((response) => {
                    var res = response.data;
                    if (res.status == "SUCCESS") {
                        this.recommendClinic = res.result;
                    }
                }).catch((error) => {
                    console.log('数据获取失败,请稍后再试!');
                });
            },
            goClinicDetail(id) {
                window.location.href = window.commonRoot + "/clinic/detail" + "/" + id;
            },
            departMore(){
                if(!this.departShow){
                    this.departShow = true;
                    $("#doctor-depart").css({
                        "height":"auto"
                    });
                    $("#depart-triangle").removeClass('triangle-down')
                    $("#depart-triangle").addClass('triangle-up')
                }else{
                    this.departShow = false;
                    $("#doctor-depart").css({
                        "height":"55px"
                    });
                    $("#depart-triangle").removeClass('triangle-up')
                    $("#depart-triangle").addClass('triangle-down')
                }
            },
            areaMore(){
                if(!this.areaShow){
                    this.areaShow = true;
                    $("#doctor-area").css({
                        "height":"auto"
                    });
                    $("#area-triangle").removeClass('triangle-down')
                    $("#area-triangle").addClass('triangle-up')
                }else{
                    this.areaShow = false;
                    $("#doctor-area").css({
                        "height":"55px"
                    });
                    $("#area-triangle").removeClass('triangle-up')
                    $("#area-triangle").addClass('triangle-down')
                }

            }
        },
        computed: {
            ...mapGetters(['keyWord'])
        },
        created: function () {
            this.initData();
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../static/scss/page/listClinicDoctor.scss";
</style>
<style lang="scss">
    .list {
        padding-left: 80px;
        position: relative;
        .first-label {
            position: absolute;
            left: 0;
            top: 0;
        }
        .ivu-checkbox {
            display: none;
        }
        .ivu-checkbox-wrapper-checked p {
            color: #fff !important;
            background: #38a3e4;
        }
        .ivu-checkbox + span {
            margin-right: 0;
        }
    }

    .list-page {
        margin: 30px auto;
        li {
            border-radius: 100%;
            height: 40px;
            line-height: 40px;
            min-width: 40px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Doctor/list.vue